"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _formDataToObject = require("form-data-to-object");

/* eslint-disable guard-for-in, no-restricted-syntax */
var objectToFormData = function objectToFormData(object) {
  var data = new FormData();
  var adjustedObject = (0, _formDataToObject.fromObj)(object);

  for (var key in adjustedObject) {
    data.append(key, adjustedObject[key]);
  }

  return data;
};

var _default = function _default(url, data) {
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, objectToFormData(data));
  } else {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, false); // third parameter indicates sync xhr

    xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
    xhr.send(JSON.stringify(data));
  }
};

exports.default = _default;